import { ConfigurationError } from '@cian/peperrors/shared';
import * as React from 'react';

import { useContext } from '../../utils/useContext';
import { FallbackModalContainer } from '../FallbackModalContainer';
import { SaveSearchModalContainer } from '../SaveSearchModalContainer';

export const RootContainer: React.FC = () => {
  const context = useContext();
  if (!context) {
    throw new ConfigurationError({
      domain: 'SaveSearchModal',
      message: "SaveSearchModal used outside of it's context",
    });
  }

  return (
    <>
      {/*
       * Микрофронтенд рендерится по наличию манифеста, а не по статусу `succeed`: ему нужно попасть в DOM,
       * чтобы смонтироваться и отдать локальное API. По той же причине его нельзя размонтировать
       * при статусе `failed` — иначе `disconnectedCallback` уничтожит инстанс и ретрай будет невозможен.
       */}
      {context.manifest && <SaveSearchModalContainer />}
      {context.open && <FallbackModalContainer />}
    </>
  );
};
